<template>
	<section class="list">
		<div>
			<table border="1">
				<thead>
					<tr>
						<slot name="columns"></slot>
					</tr>
				</thead>
				<tbody>
					<slot name="datasource"></slot>
					<!--<slot name="tips"></slot>-->
					<tr v-show="totalCount <=0">
						<td colspan="20" ><p class="p-20">暂无数据 (˘•ω•˘)</p></td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="operate-pages fx fx-x-between fx-y-center">
			<div class="">
				<slot name="operate"></slot>
			</div>
			<div class="fx-y-center">
				<pages :offset="offset" :count="count" :total-count="totalCount" @handleOffset="handleOffset"></pages>
			</div>
		</div>
	</section>
</template>
<script>
	import Pages from "./Pages.vue";
	export default {
		name: 'z-table',
		components: {
			Pages
		},
		/*
		 * 接收父组件数据
		 */
		data() {
			return {}
		},
		props: {
			offset: {
				type: Number,
				default: 0
			},
			count: {
				type: Number,
				default: 0
			},
			totalCount: {
				type: Number,
				default: 0
			}
		},

		/*
		 * 处理事件
		 */
		methods: {
			handleOffset(index) {
				this.$emit('handleOffset', index)
			}
		}
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.operate-pages {
		border-top: 0;
		padding: px-em(30px);
		background: $color-white;
	}
	/*list*/

	.list {
		background: $color-white;
		overflow-x: auto;
		overflow-y: hidden;
		width: 100%;
		&::-webkit-scrollbar-track-piece {
		    width: 2px;
		    background-color: #f8f8f8;
		}

		&::-webkit-scrollbar {
		    width: 2px;
		    height: 5px;
		    background-color: #2882e8;
		}

		&::-webkit-scrollbar-thumb {
		    width: 2px;
		    background-color: #aeaeae;
		}
		&::-webkit-scrollbar-thumb:hover {
		    background-color: #2882e8;
		}
	}

	.list table {
		width: 100%;
		border: $color-border 1px solid;
	}
	.list table td,
	.list table th {
		border: $color-border 1px solid;
		padding: px-em(20px) px-em(10px);
		min-width: 100px;
	}

	.list table th {
		padding: px-em(40px) px-em(10px);
		text-align: center;
		font-weight: normal;
		background: $color-f2f2f2;
	}

	.list table th a {
		color: $color-font;
	}

	.list table td {
		font-size: 12px;
		text-align: center;
	}

	.list table td.operating {
		min-width: 200px;
	}

	.list table td.operating span {
		padding: 0 3px 0 5px;
		color: $color-border;
	}

	.list table tr td:nth-of-type(1),
	.list table tr th:nth-of-type(1) {
		padding: 10px;
	}

	.list table tr {
		transition: all 0.2s linear;
		-webkit-transition: all 0.2s linear;
	}

	.list table tr:hover {
		background: rgba(204, 204, 204, 0.2);
	}
</style>


// WEBPACK FOOTER //
// Table.vue?611fe146